import { render, staticRenderFns } from "./ed-card.component.vue?vue&type=template&id=195f1eca&scoped=true&"
import script from "./ed-card.component.ts?vue&type=script&lang=ts&"
export * from "./ed-card.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-card.component.scss?vue&type=style&index=0&id=195f1eca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195f1eca",
  null
  
)

export default component.exports